import * as yup from 'yup';

yup.addMethod(yup.string, 'kanaFormat', function kanaFormat(field) {
  return this.matches(/^[-ぁ-ゞァ-ヴ\u2010\u2014\u2015\u2212\u30fc\uff0d]+$/u, {
    message: `${field}はひらがな・カタカナのみ使用できます`,
    name: 'kana',
    excludeEmptyString: true
  });
});

yup.addMethod(yup.string, 'phoneFormat', function phoneFormat(message) {
  const normilizePhone = phone => {
    // ハイフンっぽいものを全て削除
    if (!phone) return '';
    const deletedHyphenPhoneNumber = phone.replace(
      /[-\u2010\u2014\u2015\u2212\u30fc\uff0d]/g,
      ''
    );
    // 全角数字を半角に
    const normilizedPhoneNumber = deletedHyphenPhoneNumber.replace(
      /[０-９]+/g,
      fullwidthNumber => {
        return fullwidthNumber
          .split('')
          .map(c => {
            return String.fromCharCode(c.charCodeAt(0) - 0xfee0);
          })
          .join('');
      }
    );
    return normilizedPhoneNumber;
  };
  return this.test({
    name: 'phoneFormat',
    test: phone => {
      const normilizedPhoneNumber = normilizePhone(phone);
      return /^[-\u2010\u2014\u2015\u2212\u30fc\uff0d0-9０-９]+$/.test(
        normilizedPhoneNumber
      );
    },
    message: `${(message && message['format']) ||
      '電話番号は正しい形式で入力してください'}`
  }).test({
    name: 'phoneLength',
    test: phone => {
      const normilizedPhoneNumber = normilizePhone(phone);
      const validLength = /^(090|080|070|050)/.test(normilizedPhoneNumber)
        ? 11
        : 10;
      return normilizedPhoneNumber.length === validLength;
    },
    message: `${(message && message['length']) ||
      '電話番号の桁数が正しくありません'}`
  });
});

yup.addMethod(yup.string, 'emailFormat', function emailFormat(message) {
  return this.test({
    name: 'emailFormat',
    test: email => {
      if (!email) return true;
      // 1つの正規表現にして一度にtestすると、マッチが非常に重くなり数十文字で固まってしまうため、@の前後で分離
      const splitted = email.split('@');
      if (splitted.length != 2) {
        return false;
      }
      const local = splitted[0];
      const domain = splitted[1];

      const LOCAL_PATTERN = /^[_a-z0-9-]+([\.\+_a-z0-9-]+)*$/i;
      const DOMAIN_PATTERN = /^[a-z0-9-]+([\.][a-z0-9-]+)+$/i;
      return LOCAL_PATTERN.test(local) && DOMAIN_PATTERN.test(domain);
    },
    message: message || 'Eメールの形式が正しくありません'
  });
});

yup.addMethod(yup.string, 'requirement', function requirement(
  required,
  message
) {
  return required ? this.required(message) : this.notRequired(message);
});
yup.addMethod(yup.number, 'requirement', function requirement(
  required,
  message
) {
  return required ? this.required(message) : this.notRequired(message);
});

export default yup;
